<template>
  <div>
    <custom-dragging-list
      :data-list="dataList"
      @draggable="onDraggable"
    >
      <div class="item-box" slot-scope="rowItem">
        <img
          style="height: 80px;width: 120px;position: absolute;top: 9px;left: 1px;"
          src="http://a2.att.hudong.com/36/48/19300001357258133412489354717.jpg"/>
        <div style="position: absolute;top: 0;left: 140px;height: 100%;width: calc(100% - 200px)">
          <span>{{ rowItem.record.name }}</span>
          <br>
          <span>{{ rowItem.record.key }}</span>
        </div>
      </div>
    </custom-dragging-list>
  </div>
</template>

<script>
//先安装 npm install vuedraggable
import CustomDraggingList from '@/customComponents/CustomDraggingList'

export default {
  name: 'TestCustomDraggingList',
  components: { CustomDraggingList },
  data() {
    return {
      dataList: [
        { name: 'text1', key: 1 },
        { name: 'text2', key: 2 },
        { name: 'text3', key: 3 },
        { name: 'text4', key: 4 },
        { name: 'text5', key: 5 },
        { name: 'text6', key: 6 },
        { name: 'text7', key: 7 }
      ]
    }
  },
  mounted() {
  },
  methods: {
    onDraggable(dataList) {
      this.dataList = dataList
      console.error('=======', dataList)
    }
  }

}
</script>
<style scoped>
.item-box {
  position: relative;
  width: 100%;
  height: 100px;
  margin-top: 20px;
  background-color: white;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
}

span {
  height: 20px;
  line-height: 20px;
}
</style>